
































import Vue from 'vue';
import Component from 'vue-class-component';

import ProcessList from './list/ProcessList.vue';
import ProcessContainer from './container/ProcessContainer.vue';

@Component({ components: { ProcessContainer, ProcessList } })
export default class Process extends Vue { }
